export default __webpack_public_path__ + "static/media/ic_more.c1680e71.svg";